<template>
	<div class="upgrade-flag-wrapper">
		<div class="upgrade-flag">
			<div
				class="upgrade-flag__bg"
				:class="`bg-flag-${flagVariant}-89`"
			/>
			<div class="upgrade-flag__content">
				<div class="upgrade-axe-hammer-icon" />
				<div v-if="isEventType" class="upgrade-event-ribbon">
					{{ translate("event.event") }}
				</div>
				<div class="level">
					<span>{{ translate("ui.level") }}</span>
					<span>{{ `${currentLevel}/${maxLevel}` }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import type { EventFlagVariant, FlagVariant } from "@/types/upgrades";
import { translate } from "@/utils/translate";

interface Props {
	currentLevel: number;
	maxLevel: number;
	flagVariant: FlagVariant | EventFlagVariant;
	isEventType?: boolean;
}

const {
	currentLevel = 0,
	maxLevel = 5,
	flagVariant = "green",
	isEventType = false,
} = defineProps<Props>();
</script>

<style scoped lang="scss">
.upgrade-flag {
	position: relative;

	&__content {
		position: absolute;
		top: 0;
		left: 0;
		padding-bottom: 1.625rem;
		width: 100%;
		height: 100%;
		@include flex-col-center;
		gap: 0.438rem;

		.upgrade-axe-hammer-icon {
			position: relative;
			margin-top: 0.813rem;
			background: url($path-icons + "upgrades/upgrade-axe-hammer.avif?v2")
				no-repeat center;
			background-size: contain;
			width: 3.688rem;
			height: 3.188rem;
		}

		.upgrade-event-ribbon {
			position: absolute;
			top: 1.6rem;
			@include flex-row-center;
			margin-top: 0.813rem;
			background: url($path-events + "christmas/backgrounds/event-upgrade-ribbon.avif")
				no-repeat center;
			background-size: contain;
			padding-bottom: 0.1rem;
			width: 6.438rem;
			height: 1.563rem;
			color: #fff3dd;
			font-weight: bold;
			font-size: 0.806rem;
			text-transform: uppercase;
		}

		.level {
			@include flex-col-center;
			color: #f2dcb5;

			span {
				font-weight: 800;
				font-size: 0.875rem;
				line-height: 0.875rem;
				text-shadow: 0.044rem 0.044rem 0.063rem rgba(0, 0, 0, 0.6);
				text-transform: uppercase;
			}
		}
	}
}
</style>
